import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug    = false
globalThis.Stimulus      = application

export { application }
